module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: ['pt-page', 'pt-page-2', 'mod-how_works',
      _vm.meanList[3].clicked ? 'pt-page-current' : '',
      _vm.meanList[3].leave ? 'pt-page-moveToTop pt-page-current' : '',
      _vm.meanList[3].enter ? 'pt-page-scaleUp' : ''
    ],
    attrs: {
      "id": "mod-how_works"
    }
  }, [_c('div', {
    staticClass: "mod-section-how-works content-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "base clearfix anim"
  }, [_c('div', {
    staticClass: "step-1"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('svg', {
    staticClass: "svg replaced-svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "id": "Ebene_1",
      "data-name": "Ebene 1",
      "viewbox": "0 0 107.75 53"
    }
  }, [_c('title', [_vm._v("icon_01")]), _c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "1.5",
      "y": "1.5",
      "width": "30.67",
      "height": "50",
      "rx": "5",
      "ry": "5"
    }
  }), _c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "16.8",
      "cy": "43.8",
      "r": "2.6"
    }
  }), _c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "75.58",
      "y": "9.6",
      "width": "30.67",
      "height": "37",
      "rx": "5",
      "ry": "5"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M99.12 25.21H85.84v-5.14A2.17 2.17 0 0 1 88 17.9h9a2.17 2.17 0 0 1 2.17 2.17v5.14z",
      "transform": "translate(-1.56 -16.34)"
    }
  }), _c('path', {
    staticClass: "cls-3",
    attrs: {
      "d": "M81.29 48.68v2.75M100.29 48.68v2.75M53.35 18.85L61 26.5l-7.65 7.65M61 26.5H45.63"
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("\n        手机号：15828274523\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "step-2"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('svg', {
    staticClass: "svg replaced-svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "id": "Ebene_1",
      "data-name": "Ebene 1",
      "viewbox": "0 0 33.67 82.58"
    }
  }, [_c('title', [_vm._v("icon_02")]), _c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "1.5",
      "y": "1.5",
      "width": "30.67",
      "height": "79.58",
      "rx": "5",
      "ry": "5"
    }
  }), _c('path', {
    staticClass: "cls-2",
    attrs: {
      "d": "M26.9 34.81H7.52M26.9 41.81H7.52M26.9 48.81H7.52M24.21 26.5V7.13M17.21 26.5V7.13M10.21 26.5V7.13"
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("\n        QQ：1061087497（昵称空）\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "step-3"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('svg', {
    staticClass: "svg replaced-svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "id": "Ebene_1",
      "data-name": "Ebene 1",
      "viewbox": "0 0 53.88 46.77"
    }
  }, [_c('title', [_vm._v("icon_03")]), _c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "6.54",
      "y": "1.5",
      "width": "37",
      "height": "30.67",
      "rx": "5",
      "ry": "5"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M72.77 42.93V29.65h5.14a2.17 2.17 0 0 1 2.17 2.17v8.95a2.17 2.17 0 0 1-2.17 2.17h-5.14z",
      "transform": "translate(-28.5 -19.45)"
    }
  }), _c('path', {
    staticClass: "cls-2",
    attrs: {
      "d": "M4.46 7.21H1.71M4.46 26.21H1.71M52.38 42.13H1.5M24.68 9.19l7.65 7.64-7.65 7.65M32.33 16.83H16.96M4.44 45.27v-2.43M14.44 45.27v-2.43M24.44 45.27v-2.43M34.44 45.27v-2.43M44.44 45.27v-2.43M9.44 45.27v-2.43M19.44 45.27v-2.43M29.44 45.27v-2.43M39.44 45.27v-2.43M49.44 45.27v-2.43"
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("\n        微信：ww-930912（昵称阿伟）\n      ")])])]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('span', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "active"
  }, [_c('span', [_vm._v("联系方式：")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button-wrapper anim"
  }, [_c('a', {
    staticClass: "cta button",
    attrs: {
      "href": "https://www.vmartaw.com/zcc/about.html",
      "target": "_blank",
      "title": ""
    }
  }, [_vm._v("关于我的")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6843ef5f!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/page/Contact.vue
// module id = 241
// module chunks = 0